import { LangDto } from "@client/common";
import { array, number, object, string } from "yup";

export interface SubscriptionCancellationReasonTranslationResource {
  lang: LangDto;
  name: string;
}

export interface SubscriptionCancellationReasonResource {
  id: number;
  translations: SubscriptionCancellationReasonTranslationResource[];
}

const subscriptionCancellationReasonTranslationResourceSchema = object({
  lang: string<LangDto>().required(),
  name: string().required(),
});

export const subscriptionCancellationReasonResourceSchema = object({
  id: number().required(),
  translations: array()
    .of(subscriptionCancellationReasonTranslationResourceSchema)
    .required(),
});
